// const osmTilesUrl =
//   'https://tiles-n.elcri.men/mexico-tiles/{z}/{x}/{y}.pbf'
// no fonts or sprites on surge
// const osmTilesUrl =
//   'https://1777226290242-tiles-elcrimen.surge.sh/mexico-tiles/{z}/{x}/{y}.pbf'

// const osmSpriteUrl = 'https://tiles-n.elcri.men/sprites/sprite'
// const osmGlyphsUrl =
//   'https://tiles-n.elcri.men/font/{fontstack}/{range}.pbf'
// const osmSpriteUrl = `https://tiles-kinsta.elcri.men/sprites/sprite`
// const osmGlyphsUrl = `https://tiles-kinsta.elcri.men/font/{fontstack}/{range}.pbf`

const osmTilesUrl =
  'https://tiles-kinsta.elcri.men/mexico-tiles/{z}/{x}/{y}.pbf.html'

const osmSpriteUrl = 'https://elcri.men/tiles/sprites/sprite'
const osmGlyphsUrl = 'https://elcri.men/tiles/font/{fontstack}/{range}.pbf'

exports.osmSpriteUrl = osmSpriteUrl
exports.osmGlyphsUrl = osmGlyphsUrl
exports.osmTilesUrl = osmTilesUrl
